import ProjectsAPI from '../../../services/api/admin/projects-api';
import PackagesAPI from '../../../services/api/admin/packages-api';
import Logger from '../../../utils/logger';

export const addProject = async (project, token) => {
  Logger.userAction('Adding project via helper', { project });

  try {
    const addedProject = await ProjectsAPI.create(project, token);
    Logger.info('Project added successfully via helper', {
      project: addedProject,
    });

    return { data: { data: { addedProject } } }; // Return in expected format for backward compatibility
  } catch (err) {
    Logger.error('Error adding project to backend', err);

    const errorMessage = err.response?.data?.message || err.message;
    alert(errorMessage);
    throw new TypeError(errorMessage);
  }
};

export const addPackage = async (newPackage, token) => {
  Logger.userAction('Adding package via helper', { package: newPackage });

  try {
    const addedPackage = await PackagesAPI.create(newPackage, token);
    return { data: { data: { addedPackage } } }; // Return in expected format for backward compatibility
  } catch (err) {
    Logger.error('Error adding package to backend', err);

    const errorMessage = err.response?.data?.message || err.message;
    alert(errorMessage);
    throw new TypeError(errorMessage);
  }
};
